import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CampaignStep } from '../campaign-step';
import { Campaign } from '../campaign';
import { TriplePercentageSliderComponent } from './triple-percentage-slider/triple-percentage-slider.component';
import { CampaignService } from '../../../../services/campaign/campaign.service';
import { Percentages } from './triple-percentage-slider/percentages.model';


@Component({
  selector: 'campaign-step-3',
  templateUrl: 'campaign-step-3.html',
})
export class CampaignStep3Component implements CampaignStep {

  @Input() campaign: Campaign;
  @Output() campaignNameError: EventEmitter<boolean> = new EventEmitter();
  @Output() budgetChanged: EventEmitter<number> = new EventEmitter();
  @Output() discountsChanged: EventEmitter<number[]> = new EventEmitter();

  @ViewChild(TriplePercentageSliderComponent) child:TriplePercentageSliderComponent;


  public errors: Array<any> = [];
  public warnings: Array<any> = [];
  public budgets: Array<any> = [];

  constructor(private translateService: TranslateService, private campaignService: CampaignService) {

  }

  ngOnInit() {
    // cache request
    const defaults = this.campaign.getCreateCampaignDefaultFormData;
    const labels = this.campaign.getCreateCampaignFormData;

    // total budget
    this.campaign.budget = this.campaign.budget || 0;

    // notes
    this.campaign.notes = this.campaign.notes || '';

    // sliders
    this.translateService.get('campaign').subscribe(campaign =>
    {
      const checkPercentageDiscount = parseFloat(defaults.campaignBudgetConditionCheckModel.checkPercentageDiscount);
      const checkMonetaryAmount = parseFloat(defaults.campaignBudgetConditionCheckModel.checkMonetaryAmount);
      const checkLoyaltyPoints = parseFloat(defaults.campaignBudgetConditionCheckModel.checkLoyaltyPoints);
      this.campaign.percentageDiscount = this.campaign.percentageDiscount || parseInt(defaults.campaignBudgetPrefilModel.percentageDiscount);
      this.campaign.monetaryDiscount = this.campaign.monetaryDiscount || parseInt(defaults.campaignBudgetPrefilModel.monetaryAmount);
      this.campaign.loyaltyPoints = this.campaign.loyaltyPoints || parseInt(defaults.campaignBudgetPrefilModel.loyaltyPoints);
      // this.inputValues = new Percentages(this.campaign.percentageDiscount, this.campaign.monetaryDiscount, this.campaign.loyaltyPoints);

      this.campaignService.getMeccaniche().subscribe(
        mecc => {
          mecc.map(
            m => this.budgets.push({
              id: m.budgetId,
              name: m.name,
              min: 0,
              max: 100,
              check: null,
              value: 0
            })
          )
        },
        err => console.log(err),
        () => this.campaignService.getPrefillMeccaniche(this.campaign.targetId).subscribe(res => {
          if (this.budgets.length > 0 && res.monetaryAmount) {
            this.budgets[0].check = checkMonetaryAmount;
            this.budgets[0].value = parseInt(res.monetaryAmount);
            this.child.updateMin(parseInt(res.monetaryAmount));

            if (this.budgets[1] && res.percentageDiscount) {
              this.budgets[1].check = checkPercentageDiscount;
              this.budgets[1].value = parseInt(res.percentageDiscount);
              this.child.updateMid(parseInt(res.percentageDiscount));
            }

            if (this.budgets[2] && res.loyaltyPoints) {
              this.budgets[2].check = checkLoyaltyPoints;
              this.budgets[2].value = parseInt(res.loyaltyPoints);
              this.child.updateMax(parseInt(res.loyaltyPoints));
            }
          }
        })
      );
      this.updateBudget();
    });

  }

updateBudget() {
    if (this.campaign.budget == 0) {
      return;
    }

    let min_sum = 0;
    for (let budget of this.budgets) {
      budget.min = Math.ceil(budget.check * 100 / this.campaign.budget);
      min_sum += budget.min;
    }

    for (let budget of this.budgets) {
      budget.max = 100 - min_sum + budget.min;
    }

    for (let budget of this.budgets) {
      const size = budget.max - budget.min;
      const right = 100 - budget.max;
      const bgRight = right * 100 / (100 - size);
    }
  }

  public isStepCompleted() {
    if (typeof this.campaign === 'undefined') {
      return false;
    }

    // check budget
    if (this.campaign.budget == 0) {
      return false;
    }

    // reset errors
    this.errors = [];
    this.warnings = [];
    let minBudget = 0;
    let sumPercentages = 0;

    for (let budget of this.budgets) {
      minBudget += budget.check;
      sumPercentages += this.campaign[budget.model];

      if (this.campaign.budget * this.campaign[budget.model] / 100 < budget.check) {
        this.warnings.push({
          severity: 'warn',
          summary: 'Error',
          detail: budget.name + ' deve essere almeno '+ budget.min + '%'
        });
      }
    }
    this.budgetChanged.emit(minBudget);
    return this.errors.length == 0 && this.warnings.length == 0;
  }

  percentagesHandler(percentages: Percentages) {
    this.budgets[0].value = percentages.first;
    this.budgets[1].value = percentages.second;
    this.budgets[2].value = percentages.third;
    this.discountsChanged.emit(this.budgets);
  }

  updateSlider(event: any) {
    let name = event.target.name;
    let value = parseInt(event.target.value);
    if (name === 'Sconto a valore') {
      this.child.updateMin(value);
    } else if (name === 'Sconto in percentuale') {
      this.child.updateMid(value);
    } else {
      this.child.updateMax(value);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-3/campaign-step-3.component.ts